var React = require('react');

function BackArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.70687 1.7071C10.0974 1.31657 10.0974 0.683401 9.70685 0.292882C9.31632 -0.0976359 8.68316 -0.0976262 8.29264 0.292904L0.292882 8.2929C-0.0976275 8.68343 -0.0976275 9.31657 0.292882 9.7071L8.29264 17.7071C8.68316 18.0976 9.31632 18.0976 9.70685 17.7071C10.0974 17.3166 10.0974 16.6834 9.70687 16.2929L3.41416 10H19C19.5523 10 20 9.55229 20 9C20 8.44771 19.5523 8 19 8H3.41416L9.70687 1.7071Z","fill":"#54477B"}));
}

BackArrow.defaultProps = {"width":"20","height":"18","viewBox":"0 0 20 18","fill":"none"};

module.exports = BackArrow;

BackArrow.default = BackArrow;
